import {httpGet, httpPatch, httpPost} from "../libs/http";

export const getWMRProjects = (page, per_page, search_query, filters, onSuccess, onFailure) => dispatch => {
    let search = [];

    for(let i = 0; i < search_query.length; i++) {
        search.push('search=' + search_query[i]);
    }

    let search_param = '';

    if(search.length > 0) {
        search_param = '&' + search.join('&')
    }

    let filter_param = '';

    if(filters !== null) {
        let filter_keys = Object.keys(filters);

        for(let i = 0; i < filter_keys.length; i++) {
            if(filters[filter_keys[i]] !== null) {
                for(let j = 0; j < filters[filter_keys[i]].length; j++) {
                    filter_param += '&' + filter_keys[i] + '=' + filters[filter_keys[i]][j];
                }
            }
        }
    }

    httpGet('/website-restoration/?page=' + page + '&per_page=' + per_page + search_param + filter_param, (res) => onSuccess(res), (err) => onFailure(err));
};

export const addWMRProject = (data, onSuccess, onFailure) => dispatch => {
    httpPost('/website-restoration/', data, (res) => onSuccess(res), (err) => onFailure(err));
}

export const loadWRMProject = (guid, onSuccess, onFailure) => dispatch => {
    httpGet('/website-restoration/' + guid + '/', (res) => onSuccess(res), (err) => onFailure(err));
}

export const updateWRMProject = (guid, data, onSuccess, onFailure) => dispatch => {
    httpPatch('/website-restoration/' + guid + '/', data,  (res) => onSuccess(res), (err) => onFailure(err));
}

export const loadWRMProjectURLs = (guid, onSuccess, onFailure) => dispatch => {
    httpGet('/website-restoration/' + guid + '/urls/', (res) => onSuccess(res), (err) => onFailure(err));
}
export const loadWRMProjectAssets = (guid, onSuccess, onFailure) => dispatch => {
    httpGet('/website-restoration/' + guid + '/assets/', (res) => onSuccess(res), (err) => onFailure(err));
}

export const createWRMProject = (data, onSuccess, onFailure) => dispatch => {
    httpPost('/website-restoration/', data,  (res) => onSuccess(res), (err) => onFailure(err));
};

export const uploadWRMProject = (guid, onSuccess, onFailure) => dispatch => {
    httpPost('/website-restoration/' + guid + '/upload/', {},  (res) => onSuccess(res), (err) => onFailure(err));
}

export const restartWRMProject = (guid, onSuccess, onFailure) => dispatch => {
    httpPost('/website-restoration/' + guid + '/restart/', {},  (res) => onSuccess(res), (err) => onFailure(err));
}

export const cancelWRMProject = (guid, onSuccess, onFailure) => dispatch => {
    httpPost('/website-restoration/' + guid + '/cancel/', {},  (res) => onSuccess(res), (err) => onFailure(err));
}


